/*
 * Fancy Froggy - Add to cart on product cards, site-wide.
 *
 * Only products with options need this file. A single-variant card is a plain
 * product form that product-form.js submits on its own. For the rest, the
 * Add to cart button opens a small picker on the card
 * (snippets/ff-quick-add.liquid). The dropdowns are matched to a variant, that
 * variant's id goes into the form, and Add to cart submits through
 * product-form.js like everything else - so the theme's add-to-cart popup opens
 * exactly as it does on a product page.
 *
 * Also:
 *   - choosing a colour swatch on the card preselects that colour in the picker;
 *   - values that are sold out with the other current choices say so;
 *   - Escape, the close button or a click elsewhere closes the picker;
 *   - the picker closes itself once the add-to-cart popup opens.
 *
 * Works on every card type on the site. Listeners are delegated from the
 * document, so cards the theme editor re-renders keep working. Loaded once from
 * layout/theme.liquid; guarded so an extra include is harmless.
 */
(function () {
  if (window.ffQuickAddReady) return;
  window.ffQuickAddReady = true;

  /* Every kind of product card that can hold a picker. */
  var CARD = '[data-ffqa-card], .ffcs-card, .card-wrapper';

  function text(key, fallback) {
    var strings = window.variantStrings || {};
    return strings[key] || fallback;
  }

  function parts(root) {
    return {
      open: root.querySelector('[data-ffqa-open]'),
      panel: root.querySelector('[data-ffqa-panel]'),
      selects: Array.prototype.slice.call(root.querySelectorAll('[data-ffqa-option]')),
      id: root.querySelector('input[name="id"]'),
      add: root.querySelector('[data-ffqa-add]'),
      label: root.querySelector('[data-ffqa-label]'),
      price: root.querySelector('[data-ffqa-price]')
    };
  }

  function variants(root) {
    if (!root.ffqaVariants) {
      var el = root.querySelector('[data-ffqa-variants]');
      try {
        root.ffqaVariants = el ? JSON.parse(el.textContent) : [];
      } catch (e) {
        root.ffqaVariants = [];
      }
    }
    return root.ffqaVariants;
  }

  /* Does this variant agree with the choices, ignoring option `skip`? */
  function agrees(variant, chosen, skip) {
    for (var i = 0; i < chosen.length; i++) {
      if (i !== skip && variant.options[i] !== chosen[i]) return false;
    }
    return true;
  }

  function update(root) {
    if (!root) return;
    var p = parts(root);
    if (!p.add || !p.id) return;

    var list = variants(root);
    var chosen = p.selects.map(function (select) { return select.value; });

    p.selects.forEach(function (select, i) {
      Array.prototype.forEach.call(select.options, function (option) {
        var buyable = list.some(function (v) {
          return v.available && v.options[i] === option.value && agrees(v, chosen, i);
        });
        option.textContent = buyable ? option.value : option.value + ' - ' + text('soldOut', 'Sold out');
      });
    });

    var variant = null;
    for (var j = 0; j < list.length; j++) {
      if (agrees(list[j], chosen, -1)) {
        variant = list[j];
        break;
      }
    }

    if (!variant) {
      p.add.disabled = true;
      if (p.label) p.label.textContent = text('unavailable', 'Unavailable');
      return;
    }

    p.id.value = variant.id;
    if (p.price) p.price.innerHTML = variant.price;
    p.add.disabled = !variant.available;
    if (p.label) {
      p.label.textContent = variant.available ? text('addToCart', 'Add to cart') : text('soldOut', 'Sold out');
    }
  }

  function close(root, returnFocus) {
    if (!root) return;
    var p = parts(root);
    if (!p.panel || p.panel.hidden) return;
    p.panel.hidden = true;
    if (p.open) {
      p.open.setAttribute('aria-expanded', 'false');
      if (returnFocus) p.open.focus();
    }
    var card = root.closest(CARD);
    if (card) card.classList.remove('ffqa-open');
  }

  function closeAll(except) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ffqa]'), function (root) {
      if (root !== except) close(root, false);
    });
  }

  function open(root) {
    var p = parts(root);
    if (!p.panel) return;
    closeAll(root);
    update(root);
    p.panel.hidden = false;
    if (p.open) p.open.setAttribute('aria-expanded', 'true');
    var card = root.closest(CARD);
    if (card) card.classList.add('ffqa-open');
    var first = p.selects[0] || p.add;
    if (first) first.focus();
  }

  /* A swatch on the card carries the colour name in its title. */
  function syncSwatch(swatch) {
    var card = swatch.closest(CARD);
    var root = card && card.querySelector('[data-ffqa]');
    var name = swatch.getAttribute('title');
    if (!root || !name) return;
    parts(root).selects.forEach(function (select) {
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].value === name) {
          select.value = name;
          break;
        }
      }
    });
    update(root);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var swatch = target.closest('.ff-swatch');
    if (swatch && swatch.closest(CARD)) {
      syncSwatch(swatch);
      return;
    }

    var opener = target.closest('[data-ffqa-open]');
    if (opener) {
      var root = opener.closest('[data-ffqa]');
      var panel = root && root.querySelector('[data-ffqa-panel]');
      if (!panel) return;
      if (panel.hidden) {
        open(root);
      } else {
        close(root, true);
      }
      return;
    }

    var closer = target.closest('[data-ffqa-close]');
    if (closer) {
      close(closer.closest('[data-ffqa]'), true);
      return;
    }

    if (!target.closest('[data-ffqa-panel]')) closeAll(null);
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var select = target.closest('[data-ffqa-option]');
    if (select) update(select.closest('[data-ffqa]'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var panel = target.closest('[data-ffqa-panel]');
    if (panel) close(panel.closest('[data-ffqa]'), true);
  });

  function watchCartPopup() {
    var popup = document.getElementById('cart-notification');
    if (!popup || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      if (popup.classList.contains('active')) closeAll(null);
    }).observe(popup, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartPopup);
  } else {
    watchCartPopup();
  }
})();